import Lead from "./Lead" ;
import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;


  export default  class  Job extends  DBObject {  private static readonly _LEAD: number = 0 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _lead: Lead = null ;
 public constructor ( d3eParams ? : Partial<{lead: Lead}> ) {
 super();

this.setLead(d3eParams?.lead ?? null);
 }
  public get d3eType (  ) : string {
 return 'Job' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get lead (  ) : Lead {
 return this._lead ; 
 }
  public setLead ( val : Lead ) : void {
 let isValChanged :boolean=this._lead !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(Job._LEAD,this._lead);

this.updateObservable('lead',this._lead,val);

this._lead=val;

this.fire('lead',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case Job._LEAD : {
 return this._lead ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : Job {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :Job=( dbObj as Job );

obj.id=this.id;

obj.setLead(this._lead);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case Job._LEAD : {
 this.setLead(( value as Lead ));
 break; }
 }
 }
 }